<template>
    <DsCard class="empty-state-card">
        <img
            class="setup-image"
            height="72"
            width="72"
            src="/resources/broadcast/images/email-broadcasts.svg"
        />

        <h3>{{ $t('email.auth.empty.header') }}</h3>

        <p>{{ $t('email.auth.empty.body') }}</p>

        <DsOutlineButton @click="addEmailAuth">
            <template #leading>
                <DsIcon name="add" />
            </template>
            {{ $t('email.auth.empty.add-button') }}
        </DsOutlineButton>
    </DsCard>
</template>

<script>
export default {
    emits: [
        'add-email-auth',
    ],
    methods: {
        addEmailAuth() {
            this.$emit('add-email-auth');
        },
    },
};
</script>

<style lang="scss" scoped>
.empty-state-card {
    padding: $spacing-200;
    margin: $spacing-200 0;
}
</style>
